/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Task_Email_Send_ErrorInputs */

const en_task_email_send_error = /** @type {(inputs: Task_Email_Send_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to send the email: ${i?.message}`)
};

const pt_br2_task_email_send_error = /** @type {(inputs: Task_Email_Send_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Não foi possível enviar o e-mail: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Failed to send the email: {message}" |
*
* @param {Task_Email_Send_ErrorInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_email_send_error = /** @type {((inputs: Task_Email_Send_ErrorInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Email_Send_ErrorInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_email_send_error(inputs)
	return pt_br2_task_email_send_error(inputs)
});